import { render } from "./Suplier.vue?vue&type=template&id=67d782d8"
import script from "./Suplier.vue?vue&type=script&lang=js"
export * from "./Suplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__